module.exports = __webpack_public_path__ + "fonts/b3ac1bd.otf";